// extracted by mini-css-extract-plugin
module.exports = {"c1sy7ax6":"c1sy7ax6"};